<div class="row section-row" [formGroupName]="formControlName">
  <div class="col section-col">
    <h5 class="section-heading">Regulatory Investigations</h5>
  </div>
</div>
<app-capture-details [parentFormGroup]="formGroup"></app-capture-details>
